export default {
  'serialRedemption.title': 'Redeem Code',
  'serialRedemption.heading': 'Enter your serial code',
  'serialRedemption.instruction': 'After entering the code, tap “Redeem”',
  'serialRedemption.codeLabel': 'Code',
  'serialRedemption.codePlaceholder': 'Enter a serial code',
  'serialRedemption.codeHint': 'Enter 1 to 32 letters or numbers',
  'serialRedemption.submit': 'Redeem',
  'serialRedemption.successReward': 'Redemption successful. You received “{name}”.',
  'serialRedemption.successPoint':
    'Redemption successful. {quantity} points have been added.',
  'serialRedemption.successGift':
    'Redemption successful. The gift pack has been added to your coupon wallet.',
  'serialRedemption.goToCouponWallet': 'Go to Coupon Wallet',
  'serialRedemption.goToPointCard': 'View Points',
  'serialRedemption.goToPointRecords': 'View Point History',
  'serialRedemption.confirm': 'OK',
  'serialRedemption.error.SR-001':
    'This serial code does not exist. Please check it and try again.',
  'serialRedemption.error.SR-002':
    'This code has already been claimed and cannot be reused',
  'serialRedemption.error.alreadyRedeemedByMember':
    'You have already redeemed this code. The reward has been sent to your account.',
  'serialRedemption.error.SR-003':
    'This code has expired and cannot be claimed.',
  'serialRedemption.error.SR-004':
    'This offer is currently unavailable. Please contact support.',
  'serialRedemption.error.SR-005':
    'You have reached the redemption limit for this campaign.',
  'serialRedemption.error.SR-006':
    'Reward delivery failed. Please try again later',
  'serialRedemption.error.SR-007':
    'This offer has not started yet. Please claim it after the campaign begins.',
  'serialRedemption.error.SR-008': 'Please sign in before claiming the reward.',
  'serialRedemption.error.SR-010':
    'This offer is currently unavailable. Please contact support.',
  'serialRedemption.error.SR-011':
    'This offer is currently unavailable. Please contact support.',
  'serialRedemption.error.rateLimited':
    'Too many attempts. Please try again later',
  'serialRedemption.error.unknown':
    'The system is busy. Please try again later',
} as Record<string, string>;
